import { useState, useEffect } from "react";
import styled from "styled-components";
import MediaGrid from "../Layouts/MediaGrid";
import Marquee from "react-fast-marquee";
import { dat } from "../dat";
import TourDate from "../components/TourDate";
import { TourGrid } from "../Layouts/TourGrid";
import AboutGrid from "../Layouts/AboutGrid";
import KeresCube from '../img/kerescube.gif';

const generateList = (str, count) => Array.from({ length: count }, () => str);

export default function Home() {
    const [showGrid, setShowGrid] = useState(false);
    const isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    useEffect(() => {
        setTimeout(() => setShowGrid(true), 0);
    }, []);

    const Page = styled.div `
    margin: 10px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    column-gap: 10px;
    `

    const Cube = styled.img `
    max-width: 100%;
    &:hover {
    cursor: pointer;
    width: 600px;
    }
    `

    const m1Items = generateList("buy something for yourself from the shop", 10);
    const m2Items = generateList("releases", 30);

    return (
        <Page>
             <div style={{textAlign: "center"}}>
                <Cube src={KeresCube} />
                <div style={{paddingBottom: "10px"}} />
            </div>
            <div>
                <Marquee style={{marginBottom: "10px"}}>
                    {m2Items.map((item, index) => (
                            <span key={index} 
                            style={{ 
                                marginRight: "20px", 
                                fontFamily: "'5dots'", 
                                fontSize: "20pt"
                            }}>{item}</span>
                        ))}
                </Marquee>
                {showGrid ? <MediaGrid items={dat} isTouchScreen={isTouchScreen} /> : null}
                <div style={{paddingBottom: "10px"}} />
            </div>
            {/*<div style={{width: "100%", height: "700px"}}>
                <Marquee>
                    {m1Items.map((item, index) => (
                        <span key={index} 
                        style={{ 
                            marginRight: "50px", 
                            fontFamily: "'5dots'", 
                            fontSize: "20pt"
                        }}>{item}</span>
                    ))}
                </Marquee>
            </div>
            <div style={{paddingBottom: "10px"}} />*/}
            <div style={{width: "100%", height: "700px"}}>
                <Marquee>
                    {generateList("HYPERPUP in your town? More likely than you'd think...", 15).map((item, index) => (
                        <span key={index} 
                        style={{ 
                            marginRight: "50px", 
                            fontFamily: "'5dots'", 
                            fontSize: "20pt"
                        }}>{item}</span>
                    ))}
                </Marquee>
                <TourGrid />
            </div>
            <div style={{paddingBottom: "10px"}} />
            <div style={{width: "100%", height: "700px"}}>
                <Marquee>
                    {generateList("About the mess of an artist", 20).map((item, index) => (
                        <span key={index} 
                        style={{ 
                            marginRight: "50px", 
                            fontFamily: "'5dots'", 
                            fontSize: "20pt"
                        }}>{item}</span>
                    ))}
                </Marquee>
                <AboutGrid />
                <div style={{paddingBottom: "10px"}} />
            </div>
            
        </Page>
    )
}